import { TMCTableModule } from '@sdbn/common';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {  ServiceResponseModule } from '@sdbn/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivateTransportsDialogComponent } from './component/activate-transports-dialog.component';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonTranslationModule,
    MatTableModule,
    MatRadioModule,
    MatCheckboxModule
  ],
  declarations: [ActivateTransportsDialogComponent]
})
export class ActivateTransportsModule { }
